module.exports = __webpack_public_path__ + "static/media/text-align-left-black.2b87e5df.svg";